import React, { useMemo } from 'react';
import Column from 'src/components/10-atoms/layout/Column';
import Typography from 'src/components/10-atoms/typography/Typography';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import useI18n from 'src/modules/translations/hooks/useI18n';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import sortBy from 'src/utils/array/sortBy';
import styleUtils from 'src/utils/styles';
import EFTimelineItem from './EFTimelineItem';
// RNW maps role="region" to <section>.
const visuallyHidden = {
    position: 'absolute',
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: 'hidden',
};
const EFTimeline = ({ question, style, ...columnProps }) => {
    const [{ styles }] = useTheme(stylesGenerator);
    const { translate } = useI18n();
    const efLabel = translate("Examiner's Feedback");
    const feedbacks = useMemo(() => {
        const allFeedbacks = [
            ...question.duplicates,
            {
                ...question,
            },
        ];
        return sortBy(allFeedbacks, item => item.questionPaper?.data.dateNL ?? '', 'desc').map((item, i) => ({
            isCurrent: question.questionPaper?.data.dateNL === item.questionPaper?.data.dateNL,
            questionPaper: item.questionPaper,
            examinersFeedback: item.examinersFeedback,
            isLast: i === allFeedbacks.length - 1,
            isFirst: i === 0,
            question: item,
        }));
    }, [question.duplicates]);
    return (React.createElement(Column, { style: [styles.container, style], role: "region", accessibilityLabel: efLabel, ...columnProps },
        React.createElement(Typography, { role: "heading", "aria-level": 2, style: visuallyHidden }, efLabel),
        React.createElement(Column, { style: styleUtils.pagePadding }, feedbacks.map((feedback, i) => (React.createElement(EFTimelineItem, { key: i, feedback: feedback }))))));
};
const stylesGenerator = createThemedStyle(({ theme }) => ({
    container: {
        paddingTop: theme.spacing.standard.sm,
    },
}));
export default EFTimeline;
